import { SpoorwebDataDto } from "@/shared/types";
import { parseISO } from "date-fns";

export type SpoorwebData = {
    nummer: string;
    startDatumTijd: Date;
    eindDatumTijd: Date | null;
    planaanpassing?: string;
};

export const SpoorwebData = {
    fromDto: (dto: SpoorwebDataDto | undefined): SpoorwebData | undefined =>
        dto && {
            nummer: dto.nummer,
            startDatumTijd: parseISO(dto.startDatumTijd),
            eindDatumTijd: dto.eindDatumTijd ? parseISO(dto.eindDatumTijd) : null,
            planaanpassing: dto.planaanpassing,
        },
};
